import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import {
  FormControl,
  FormGroup,
  UntypedFormControl,
  Validators,
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { AddProposalService } from "../proposals/add-proposal/add-proposal.service";
import { ToastrService } from "ngx-toastr";
import { HeaderComponent } from "src/app/components/header/header.component";
import { TemplateCategoryModalComponent } from "../template-category-modal/template-category-modal.component";
import { auto } from "@popperjs/core";
import { ConstantPool } from "@angular/compiler";
import { ActivatedRoute } from "@angular/router";
import { promise } from "protractor";
import { Router } from "@angular/router";
import { themeSymbol } from "igniteui-webcomponents/theming/theming-controller";
import moment from "moment";
import { Console } from "console";
import { Location } from '@angular/common';
import { ConfirmationBackDialogComponent } from "src/app/components/confirmation-back-dialog/confirmation-back-dialog.component";
@Component({
  selector: "app-organizational-compliance-creation",
  templateUrl: "./organizational-compliance-creation.component.html",
  styleUrls: ["./organizational-compliance-creation.component.css"]
})


export class OrganizationalComplianceCreationComponent implements OnInit {
  registerForm: FormGroup;
  loading = false;
  submitted = false;
  complianceTypes: any = [];
  complianceNames: any = [];
  public formData: FormGroup;
  public locations: any = [];
  data: any = [];
  editedData: any = [];
  certifications: any = [];
  regionsData: any = [];
  public regions: any = [];
  public cities: any = [];
  public officeLocations: any = [];
  allResult: any = [];
  isloading: boolean=false;

  public selectedFileNames: string[] = [];
  @ViewChild(HeaderComponent) header: HeaderComponent;
  isFileUploaded: boolean = false;
  changesAllowedChecked: boolean = true;
  barnches: any = [];
  a: any = null;
  regionId: any;
  compType = [{ name: 'secutity' }];
  countryId: any;
  isView: boolean;
  flag: boolean = false;
  title: string = "";
  compilanceArray: any = [];
  isRegionSelected: boolean = false;
  isCountrySelected: boolean = false;
  isCitySelected: boolean = false;
  public selectedFiles: any = [];
  public fileTypeSelected: any[][] = [];
  public attachmentsValidation: any[] = [];
  fileTypeNotSelected: boolean = false;
  allowedFileExtentions: string = ".docx,.pptx,.xlsx,.pdf,.txt,.csv";
  complianceId: number = 0;
  isEditPage: boolean = false;
  compname: any;

  constructor(
    private toaster: ToastrService,
    private _addProposalService: AddProposalService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private location: Location,
    public dialog: MatDialog,
  ) { }

  async ngOnInit() {
    this.title=window.history.state.data.title;
    this.createFormControls()
      .then(() => {
        this.getCompilanceNames();
        this.getCompilanceTypes();
        this.getAllRegionsForHeader();
      });
    this.complianceId = this.activatedRoute.snapshot.params.id;
    this.activatedRoute.paramMap.subscribe(params => {
      this.isView = params.get('isView') === 'true';
    });
    if (this.complianceId) {
      this.loading = true;
      this.isEditPage = true;
      this.setformData();
      this.updateRegionByCompliance();
      this.loading = false;
      if (this.isView) {
        this.formData.disable();
        this.isEditPage = false;
      }
      this.isloading=false;
    }
  }
  async setformData(): Promise<void> {
    await this.getcompilanceData(this.complianceId)
      .then(data => {
        this.editedData = data;
        this.formData.controls['CompilanceName'].setValue(this.editedData.compilanceName);
        this.formData.controls['CompilanceType'].setValue(this.editedData.compilanceType);
        this.formData.controls['CompilanceDescription'].setValue(this.editedData.compilanceDescription);
        const startDate = moment(this.editedData.startDate).startOf('day').toDate();
        const endDate = moment(this.editedData.endDate).endOf('day').toDate();
        this.formData.controls['startDate'].setValue(startDate);
        this.formData.controls['endDate'].setValue(endDate);
        this.certifications = this.editedData.certifications;
      });
  }

  async createFormControls(): Promise<void> {
    this.formData = new FormGroup({
      CompilanceName: new FormControl("",
        [
          Validators.required,
          Validators.maxLength(150),
        ]
      ),
      CompilanceType: new FormControl(
        "",
        Validators.required
      ),
      CompilanceDescription: new FormControl(
        "",
        [
          Validators.required,
          Validators.maxLength(400),
          Validators.minLength(30)
        ]
      ),
      startDate: new FormControl(
        "",
        [
          Validators.required,
        ]
      ),
      endDate: new FormControl(
        "",
        [
          Validators.required,
        ]
      ),
      Files: new FormControl(""),
    });
  }
  getcompilanceData(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this._addProposalService.getComplianceById(id).subscribe(
        (res) => {
          this.data = {
            compliance: res.data
          };

          resolve(res.data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  async getAllRegionsForHeader(): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this._addProposalService.getAllRegions().subscribe(
        (res) => {
          this.data = {
            regions: res.data
          }
          resolve(res.data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getLocations(): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this._addProposalService.getAllCountries().subscribe((x) => {
        this.complianceTypes = x.data.items;
        var ids = this.locations.map((item) => item.id);
        x.data.items.forEach((loc) => {
          if (!ids.includes(loc.id)) {
            this.locations.push(loc);
          }
        });
        resolve(this.locations);
      });
    });
  }

  getRegions(): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this._addProposalService.getAllRegions().subscribe((x) => {
        var ids = this.regions.map((item) => item.id);

        x.data.forEach((loc) => {
          if (!ids.includes(loc.id)) {
            this.regions.push(loc);
          }
        });
        resolve(this.regions);
      });
    });
  }
  cancel() {
    const dialogRef = this.dialog.open(ConfirmationBackDialogComponent, {
      width: "550px",
      height: auto,
      data: {
        Title: "Warning!",
        Content: "You have unsaved data. Do you want to continue?",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.router.navigate(["Home/Compliance"]);
      }
    })

  }
  getFilteredList(data: any): string[] {
    data?.forEach(item => {
      let result: any = [];
      item.countries.forEach(country => {
        result.push({ name: country.name, file: null });
        country.cities.forEach(city => {
          result.push({ name: city.name, file: null });
          city.locations.forEach(location => {
            result.push({ name: location.location, file: null });
          });
        });
      });
      this.allResult.push(result);
    });
    return this.allResult;
  }
  async fileUpload(data) {

    let file = await this.documentUpload(data);
    if (file && file.length) {
      this.data.file = file[0];
      this.data.fileName = file[0].name;
      this.data.regions.forEach(region => {
        this.changeRegionFileStatus(region, file[0].name);
      })
    }
  }
  deleteFile() {
    this.data.regions.forEach(region => {
      this.changeRegionFileStatus(region, null)
    })
    this.data.fileName = null;
    this.data.file = null;
    if (this.editedData.certifications) {
      this.certifications = [];
    }

  }
  async countryFileChange(country, data) {
    let file = await this.documentUpload(data);
    if (file && file.length) {
      country.file = file[0];
      this.changeCountryFileStatus(country, file[0].name);
    }
  }
  async cityFileChange(city, data) {
    let file = await this.documentUpload(data);
    if (file && file.length) {
      city.file = file[0];
      this.changeCityFileStatus(city, file[0].name);
    }
  }
  async locationFileChange(location, data) {
    let file = await this.documentUpload(data);
    if (file && file.length) {
      location.file = file[0];
      location.fileName = file[0].name;
    }
  }

  changeCityFileStatus(city, fileName: string) {
    if (city) {
      city.fileName = fileName;
      if (city?.locationList.length > 0)
        city.locationList.forEach(l => {
          l.fileName = fileName;
        })
    }
  }
  changeCountryFileStatus(country, fileName: string) {
    if (country) {
      country.fileName = fileName;
      if (country?.cityList.length > 0)
        country.cityList.forEach(city => {
          this.changeCityFileStatus(city, fileName);
        })
    }
  }
  changeRegionFileStatus(region, fileName: string) {
    if (region) {
      region.fileName = fileName;
      if (region?.countryList.length > 0)
        region.countryList.forEach(country => {
          this.changeCountryFileStatus(country, fileName);
        })
    }
  }
  async documentUpload(data): Promise<any> {
    if (!data.length) {
      this.toaster.error("Something went wrong, try again");
      return;
    }
    const allowedDoctumnetTypes = ["docx", "pdf", "pptx", "xlsx"];
    this.isFileUploaded = true;
    let files = [...new Set(Array.from(data))];
    let allPromises = files.map((file) => this.convertFile(file));

    const res = await Promise.all(allPromises);
    const validFiles = res.filter((file: any) => {
      const fileType = file.name.split(".").at(-1);
      if (allowedDoctumnetTypes.includes(fileType)) {
        if (this.isFileSelected(file)) {
          this.toaster.warning("This file is already selected.");
          return false;
        }
        this.selectedFiles.push(file);
        this.fileTypeSelected.push([]);
        this.attachmentsValidation.push({
          isTouched: false,
        });
        return true;
      } else {
        this.toaster.error(
          'Please upload any one of these documents: ["Docs", "PDF", "PPT", "Excel"]'
        );
        return false;
      }
    });
    return validFiles;
  }


  addSelectedFile(file: File): void {
    this.selectedFileNames.push(file.name);
  }

  isFileSelected(file: File): boolean {
    if (this.selectedFileNames.includes(file.name)) {
      return true;
    }
    return false;
  }

  toggleChangesAllowed() {
    this.changesAllowedChecked = !this.changesAllowedChecked;
  }

  convertFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () =>
        resolve({
          data: reader.result.toString().split(",")[1],
          mimeType: reader.result.toString().split(",")[0].split(";")[0],
          name: file.name,
          extention: file.type,
          SharePointUrl: "",
          type: [],
          fileSize: file.size.toString(),
        });
      reader.onerror = (error) => reject(error);
    });
  }

  deleteAttachment(file, city) {
    this.allResult.forEach(res => {
      res.forEach(x => {
        if (x.name == city.name)
          x.file = null;
      })
    })
  }
  extractCertifications() {
    if (this.data.file) {
      this.certifications.push({
        ...this.data.file,
        regionList: this.data.regions.map(region => ({
          ...region,
          isApplicable: true,
          countryList: region.countryList.map(country => ({
            ...country,
            isApplicable: true,
            cityList: country.cityList.map(city => ({
              ...city,
              isApplicable: true,
              locationList: city.locationList.map(location => ({
                ...location,
                isApplicable: true,
              })),
            })),
          })),
        })),
      });
    }

    this.data.regions.forEach(region => {
      let regionHasFile = false;

      if (region.file) {
        this.certifications.push({
          ...region.file,
          regionList: [{
            ...region,
            isApplicable: true,
            countryList: region.countryList.map(country => ({
              ...country,
              isApplicable: true,
              cityList: country.cityList.map(city => ({
                ...city,
                isApplicable: true,
                locationList: city.locationList.map(location => ({
                  ...location,
                  isApplicable: true,
                })),
              })),
            })),
          }],
        });
        regionHasFile = true;
      }

      region.countryList.forEach(country => {
        let countryHasFile = false;

        if (country.file) {
          this.certifications.push({
            ...country.file,
            regionList: [{
              ...region,
              isApplicable: false,
              countryList: [{
                ...country,
                isApplicable: true,
                cityList: country.cityList.map(city => ({
                  ...city,
                  isApplicable: true,
                  locationList: city.locationList.map(location => ({
                    ...location,
                    isApplicable: true,
                  })),
                })),
              }],
            }],
          });
          countryHasFile = true;
        }

        country.cityList.forEach(city => {
          let cityHasFile = false;

          if (city.file) {
            this.certifications.push({
              ...city.file,
              regionList: [{
                ...region,
                isApplicable: false,
                countryList: [{
                  ...country,
                  isApplicable: false,
                  cityList: [{
                    ...city,
                    isApplicable: true,
                    locationList: city.locationList.map(location => ({
                      ...location,
                      isApplicable: true,
                    })),
                  }],
                }],
              }],
            });
            cityHasFile = true;
          }

          city.locationList.forEach(location => {
            if (location.file) {
              this.certifications.push({
                ...location.file,
                regionList: [{
                  ...region,
                  isApplicable: false,
                  countryList: [{
                    ...country,
                    isApplicable: false,
                    cityList: [{
                      ...city,
                      isApplicable: false,
                      locationList: [{
                        ...location,
                        isApplicable: true,
                      }],
                    }],
                  }],
                }],
              });
            }
          });
        });
      });
    });

    return this.certifications;
  }
  getCompilanceNames(): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this._addProposalService.getAllCompilanceName().subscribe((x) => {
        this.complianceNames = x.data.items;
        resolve(this.complianceNames);
      });
    });
  }
  getCompilanceTypes(): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this._addProposalService.GetAllComplianceTypes().subscribe((x) => {
        this.complianceTypes = x.data.items;
        resolve(this.complianceTypes);
      });
    });
  }
  validateform() {
    var validateData = false;
    for (const control of Object.keys(this.formData.controls)) {
      if (this.formData.controls[control].status == "INVALID") {
        validateData = true;
      }
    }
    if (validateData) {
      for (const control of Object.keys(this.formData.controls)) {
        this.formData.controls[control].markAsTouched();
      }
      return false;
    }
    return true;
  }
  save() {
    let data = this.formData.getRawValue();
    if (!this.validateform()) {
      return;
    }
    let request = {
      compilanceName: data.CompilanceName,
      compilanceNameId: this.getIds(this.complianceNames, data.CompilanceName),
      compilanceType: data.CompilanceType,
      complianceTypeId: this.getIds(this.complianceTypes, data.CompilanceType),
      compilanceDescription: data.CompilanceDescription,
      startDate: new Date(data.startDate).toISOString(),
      endDate: new Date(data.endDate).toISOString(),
      certifications: this.extractCertifications()
    }
    if (this.isEditPage) {
      request['id'] = this.activatedRoute.snapshot.params.id;
      this._addProposalService.UpdateCompliance(request).subscribe((res) => {
        this.loading = false;
        this.toaster.success("Details Updated Successfully");
        this.location.back();
        setTimeout(() => {
          this.loading = true;
        }, 1000);
      }, (err) => {
        this.loading = false;
      });
    }
    else {
      this._addProposalService.createComplains(request).subscribe(res => {
        this.location.back();
      });
    }
  }
  getIds(values, name) {
    let data = values.find(x => x.name == name);
    return data?.id
  }
  async updateRegionByCompliance(): Promise<void> {
    try {
      const response = await this._addProposalService.getComplianceById(this.complianceId).toPromise();
      if (response.succeeded) {
        const complianceData = response.data;
        complianceData.certifications.forEach(certification => {
          certification.regionList.forEach(region => {
            let existingRegion = this.data.regions?.find(r => r.id === region.id);
            if (!existingRegion) {
              existingRegion = {
                id: region.id,
                name: region.name,
                isApplicable: region.isApplicable,
                countryList: [],
                fileName: null
              };
              this.data.regions?.push(existingRegion);
            }
            region.countryList.forEach(country => {
              let existingCountry = existingRegion.countryList?.find(c => c.id === country.id);
              if (!existingCountry) {
                existingCountry = {
                  id: country.id,
                  name: country.name,
                  isApplicable: country.isApplicable,
                  cityList: [],
                  fileName: null
                };
                existingRegion.countryList?.push(existingCountry);
              }
              country.cityList.forEach(city => {
                let existingCity = existingCountry.cityList?.find(c => c.id === city.id);
                if (!existingCity) {
                  existingCity = {
                    id: city.id,
                    name: city.name,
                    isApplicable: city.isApplicable,
                    locationList: [],
                    fileName: null
                  };
                  existingCountry.cityList?.push(existingCity);
                }
                city.locationList.forEach(location => {
                  let existingLocation = existingCity.locationList?.find(l => l.id === location.id);
                  if (!existingLocation) {
                    existingLocation = {
                      id: location.id,
                      name: location.name,
                      isApplicable: location.isApplicable,
                      sharePointId: location.sharePointId,
                      fileName: null
                    };
                    existingCity.locationList?.push(existingLocation);
                  }
                  if (location.isApplicable) {
                    existingLocation.fileName = certification.name;
                  }
                });
                if (city.isApplicable) {
                  existingCity.fileName = certification.name;
                }
              });
              if (country.isApplicable) {
                existingCountry.fileName = certification.name;
              }
            });
            if (region.isApplicable) {
              existingRegion.fileName = certification.name;
            }
          });
        });
        if (complianceData.file) {
          this.data.file = {
            data: complianceData.file.data,
            mimeType: complianceData.file.mimeType,
            name: complianceData.file.name,
            extention: complianceData.file.extention,
            SharePointUrl: complianceData.file.SharePointUrl,
            type: complianceData.file.type,
            fileSize: complianceData.file.fileSize
          };
        }
        const certifications = complianceData.certifications;
        let filename = '';
        if (certifications != null) {
          certifications.forEach(certification => {
            certification.regionList.forEach(region => {
              if (region.isApplicable) {
                region.countryList.forEach(country => {
                  if (country.isApplicable) {
                    country.cityList.forEach(city => {
                      if (city.isApplicable) {
                        city.locationList.forEach(location => {
                          if (location.isApplicable) {
                            filename = certification.name;
                          }
                        });
                      }
                    });
                  }
                });
              }
            });
          });
        }
        this.data.fileName = filename;
      } else {
        console.error('Compliance data fetch failed');
      }
    } catch (error) {
      console.error('Error updating region by compliance:', error);
    }
  }
}
